import { useState } from "react";

import TagManager from "react-gtm-module";
import {
    FinanceCalculationResponse,
    GetFinanceCalculationParams,
    calculateFinance,
} from "services/motorpoint/finance";
import { FinanceSubmitEventData } from "utils/generateGtmFinanceSubmitEvent";
import { logError } from "utils/logger";

const useFinanceData = () => {
    const [financeData, setFinanceData] = useState<FinanceCalculationResponse | null>(null);
    const [financeError, setFinanceError] = useState<string | null>(null);

    const getFinanceData = async (
        params: GetFinanceCalculationParams,
        event?: FinanceSubmitEventData
    ): Promise<FinanceCalculationResponse | null> => {
        try {
            const { data } = await calculateFinance(params);
            if (Array.isArray(data)) {
                setFinanceData(data);
                setFinanceError(null);

                if (event) {
                    TagManager.dataLayer({
                        dataLayer: {
                            event: "finance_calculator_submit",
                            ...event,
                        },
                    });
                }

                return data;
            }

            setFinanceError(data?.Message);
            return null;
        } catch (error) {
            logError("Failed to receive finance data.", error);
            setFinanceError("Failed to receive finance data.");

            return null;
        }
    };

    return { financeData, financeError, setFinanceData, getFinanceData };
};

export default useFinanceData;
